var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabbarSenders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51702 18H14.4977C16.1619 18 17.0147 17.1555 17.0147 15.5078V7.17846C17.0147 5.53081 16.1619 4.69457 14.4977 4.69457H2.51702C0.836245 4.69457 0 5.53081 0 7.17846V15.5078C0 17.1555 0.836245 18 2.51702 18ZM1.58141 3.36154H15.4416C15.3174 2.60809 14.9614 2.19411 14.1334 2.19411H2.8896C2.06163 2.19411 1.70561 2.60809 1.58141 3.36154ZM3.28702 1.06808H13.736C13.6863 0.364305 13.2888 0 12.5188 0H4.49585C3.73413 0 3.3367 0.364305 3.28702 1.06808Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarSenders);
export default __webpack_public_path__ + "static/media/tabbar_senders.0936b1bd8138ad7c380c6434fe65e636.svg";
export { ForwardRef as ReactComponent };